import Grid from '@material-ui/core/Grid'
import DatePicker from 'Components/DatePicker'
import Select from 'Components/Select'
import WidgetBar from 'Components/WidgetBar'
import EurestoDiv from 'EurestoComponents/EurestoDiv'
import Utils from 'EurestoFonction/Utils'
import moment from 'moment'
import React, { useEffect, useState } from 'react'

moment.locale('fr')

export default props => {

  const [date, setDate] = useState([moment().startOf('week').format('YYYY-MM-DD'), moment().endOf('week').format('YYYY-MM-DD')])
  const [view, setView] = useState(1)

  useEffect(() => {
    setDate(
      view === 1 && [moment().startOf('week').format('YYYY-MM-DD'), moment().endOf('week').format('YYYY-MM-DD')]
      || view === 2 && [moment().startOf('month').format('YYYY-MM-DD'), moment().endOf('month').format('YYYY-MM-DD')]
      || view === 3 && [moment().startOf('year').format('YYYY-MM-DD'), moment().endOf('year').format('YYYY-MM-DD')]
    )
  }, [view])

  return <Grid item style={{ margin: 0, padding: 10 }} xs={12}>
    <EurestoDiv titleStyle={{ padding: 0 }} title={
      <Grid wrap={'nowrap'} spacing={0} style={{ height: '100%', margin: 0, padding: 0, fontWeight: 'normal' }}
            container justify={'center'}
            alignContent={'center'} alignItems={'center'}>
        <Grid item xs>
          <span style={{
            textAlign: 'center',
            padding: '0px 10px',
            fontWeight: 'bold'
          }}>Historique de vos réservations</span>
        </Grid>
        <Grid item>
          <Select key={view} InputProps={{ style: { marginBottom: 0 } }} onChange={data => data && setView(data)} value={view} options={[{
            label: 'Semaine',
            value: 1
          }, {
            label: 'Mois',
            value: 2
          }, {
            label: 'Année',
            value: 3
          }]}/>
        </Grid>
        <Grid item>
          <DatePicker value={date}
                      clearDate={false}
                      key={date}
                      month={view === 2}
                      year={view === 3}
                      week={view === 1}
                      style={{ marginBottom: 0 }}
                      onChange={data => {
                        setDate(data)
                      }}/>
        </Grid>
      </Grid>} style={{ padding: 0, margin: 0 }}>
      <WidgetBar
        year={view === 3}
        module={'restaurant'}
        requete={'reservation'}
        champ_recherche={'date_reservation'}
        date_debut={date && date[0]}
        date_fin={date && date[1]}
        barData={[{
          title: 'Confirmée(s)',
          color: Utils.reservationColor(3),
          recherche: [{ champ: 'niveau', operation: 'between', 'valeur': [1, 3] }]
        },
          {
            title: 'En Attente(s)',
            color: 'grey',
            recherche: [{ champ: 'niveau', operation: 'egal', 'valeur': 0 }, {
              champ: 'date_reservation',
              operation: 'gte',
              'valeur': moment('YYYY-MM-DD')
            }]
          },
          {
            title: 'Refusée(s)',
            color: Utils.reservationColor(4),
            recherche: [{ champ: 'niveau', operation: 'egal', 'valeur': 4 }]
          },
          {
            title: 'Annulée(s)',
            color: Utils.reservationColor(5),
            recherche: [{ champ: 'niveau', operation: 'egal', 'valeur': 5 }]
          }]}/>
    </EurestoDiv>
  </Grid>
}


// WEBPACK FOOTER //
// ./app/App/Module/Home/Component/Widgets/Reservation/index.js